<template>
    <v-dialog v-model="resumeDialog" persistent max-width="480">
        <template v-slot:activator="{ on }">
            <v-btn
                v-on="on"
                color="secondary">
                Redémarrer
            </v-btn>
        </template>
        <v-card>
            <v-form ref="pauseTreatmentForm" lazy-validation>
                <v-card-title class="headline">Redémarrer le traitement</v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <h4>Etes-vous sûr de vouloir redémarrer ce traitement ?</h4>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" @click="resumeDialog = false">Annuler</v-btn>
                    <v-btn color="primary" @click="save">Oui, redémarrer</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import {getTranslationString} from "../../../helper";

    export default {
        name: "TreatmentResumeForm",
        data () {
            return {
                resumeDialog: false,
            }
        },
        computed: {
            ...mapState('medical_cases', {
                selectedMedicalCase: state => state.selectedMedicalCase,
            }),
            ...mapState('treatments', {
                selectedTreatment: state => state.selectedTreatment,
            }),
        },
        methods: {
            getText(key) {
                return getTranslationString(key)
            },
            save() {
                this.resumeDialog = false;
                if (this.selectedTreatment && this.selectedMedicalCase) {
                    this.resumeTreatment().then(response => {
                        this.$router.push({name: 'patient.viewMedicalCase', params: { medical_case_id: this.selectedMedicalCase.id }});
                    }).catch(reason => {
                        //Stay here..
                    })
                }
            },
            ...mapActions('treatments', [
                'resumeTreatment'
            ]),
        }
    }
</script>
